import React, { Fragment } from "react";
import {
  makeStyles,
  Container,
  Typography,
  Box,
  Link,
} from "@material-ui/core";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'black', 
    color: theme.palette.primary.main, 
    height: '91.3vh',
    maxWidth: '1800px',
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(6),
      minHeight: "93vh",
    },
    [theme.breakpoints.down(450)]: {
      marginTop: theme.spacing(5),
      height: "auto",
    },
  },
  mainCompanyWrapper: {
    width: "60%",
    textAlign: "center",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      width: "80%", 
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%", 
    },
  },
  heading: {
    color: theme.palette.primary.main,
    fontSize: "32px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  description: {
    color: theme.palette.primary.main,
    textAlign: "justify",
    fontSize: "18px",
    fontWeight: 300,
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  d2p: {
    fontSize: "30px",
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
    },
  },
  footer: {
    marginTop: "auto",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  footerLink: {
    margin: "0 10px",
    color: theme.palette.primary.main,
    textDecoration: "none",
  },
}));

function Company() {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <Container className={classes.mainCompanyWrapper}>
        <Typography variant="p" className={classes.heading} align="center">
          Company Overview
        </Typography>
        <Box marginTop={8}>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            d2p is the publishing division of Continent 5 Media Group, Inc.
            (C5M), designed to revolutionize the digital publishing landscape.
            The innovative KleverBook™ app is at its core, which provides
            readers free access to eBooks supported by seamlessly integrated
            advertisements. This unique approach ensures that authors and
            publishers earn ad revenue without compromising the reader's
            experience. To learn more, click the KleverBook tab below.
          </Typography>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
            style={{ marginTop: "16px" }}
          >
            Beyond the KleverBook™ app, d2p is a comprehensive platform for
            authors and publishers to showcase and distribute their work through
            our digital online bookstore. Leveraging C5M’s dynamic marketing
            network, d2p empowers writers and publishers to reach broader
            audiences—far beyond the limitations of traditional online
            bookstores.
          </Typography>
        </Box>
      </Container>
      <Container className={classes.footer}>
        <NavLink to="/register/:role" className={classes.footerLink}>
          Signup
        </NavLink>
        <NavLink to="/kleverbooks" className={classes.footerLink}>
          KleverBook
        </NavLink>
        <NavLink to="/" className={classes.footerLink}>
          Home
        </NavLink>
      </Container>
    </Container>
  );
}

export default Company;
